module.exports = __webpack_public_path__ + "img/LI109940.013dba78.png";